// 수납 내역 관리 > 검색 필터

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";

import * as API from "../../service/api";
import * as FM from "../../service/useData/format";
import * as CUS from "../../service/customHook";
import * as TOA from "../../service/library/toast";
import * as APIURL from "../../service/string/apiUrl";
import * as CLEAN from "../../service/useData/cleanup";

import * as PAGE from "../../action/page";

export default function ComponentListPaymentHistorySearch({ setList }) {
  const dispatch = useDispatch();
  const pageData = useSelector((state) => state.page.pageData, shallowEqual);
  const listFilterData = useSelector(
    (state) => state.page.listFilterData,
    shallowEqual
  );

  const { register, watch, reset, getValues, setValue, handleSubmit } = useForm(
    {}
  );

  // 마운트 / 페이지 변경 시 검색 (페이지네이션 이동 시 기존 검색 조건 복원)
  CUS.useCleanupEffect(() => {
    if (Object.keys(listFilterData).length > 2) {
      setValue("_mobilenum", listFilterData.mobilenum);
      setValue("_name", listFilterData.name);
      setValue("_cid", listFilterData.cid);
      setValue("_billYM", listFilterData.billYM);
      // 선납 시작일 범위 ( 시작=endDateFrom, 끝=startDateTo : 백엔드 DTO 필드명 기준 )
      setValue(
        "_endDateFrom",
        listFilterData.endDateFrom && listFilterData.endDateFrom.split("T")[0]
      );
      setValue(
        "_startDateTo",
        listFilterData.startDateTo && listFilterData.startDateTo.split("T")[0]
      );
      // 출금일 범위 ( 시작=paymentDateFrom, 끝=paymentDateTo )
      setValue(
        "_paymentDateFrom",
        listFilterData.paymentDateFrom &&
          listFilterData.paymentDateFrom.split("T")[0]
      );
      setValue(
        "_paymentDateTo",
        listFilterData.paymentDateTo &&
          listFilterData.paymentDateTo.split("T")[0]
      );
      fnSubmit();
    } else {
      fnSubmit();
    }
  }, [pageData.activePage]);

  // 상위 컴포넌트에게 전달받은 useState의 set 함수
  const paymentList = (res) => {
    setList && setList(res);
  };

  // submit 이벤트
  function fnSubmit(isNewSearch = false) {
    const requestData = {
      offset: isNewSearch ? 0 : pageData.getPage,
      size: 15,
    };

    // 휴대폰 ( 중간 - 자동 입력 )
    if (getValues("_mobilenum")) {
      requestData.mobilenum = FM.serviesFormatPhoneNumber(
        getValues("_mobilenum")
      );
    }

    // 상호명
    if (getValues("_name")) {
      requestData.name = getValues("_name");
    }

    // 관리번호
    if (getValues("_cid")) {
      requestData.cid = getValues("_cid");
    }

    // 청구년월 ( YYYY-MM )
    if (getValues("_billYM")) {
      requestData.billYM = getValues("_billYM");
    }

    // 선납 시작일 범위 ( 시작=endDateFrom ~ 끝=startDateTo, 백엔드 계약대로 T00:00:00 전송 )
    if (getValues("_endDateFrom")) {
      requestData.endDateFrom = `${getValues("_endDateFrom")}T00:00:00`;
    }
    if (getValues("_startDateTo")) {
      requestData.startDateTo = `${getValues("_startDateTo")}T00:00:00`;
    }

    // 출금일 범위 ( 시작=paymentDateFrom ~ 끝=paymentDateTo )
    if (getValues("_paymentDateFrom")) {
      requestData.paymentDateFrom = `${getValues("_paymentDateFrom")}T00:00:00`;
    }
    if (getValues("_paymentDateTo")) {
      requestData.paymentDateTo = `${getValues("_paymentDateTo")}T00:00:00`;
    }

    if (isNewSearch === true) {
      // 신규 검색이면 offset을 0으로 검색
      requestData.offset = 0;
      dispatch(
        PAGE.setPage({
          getPage: requestData.offset,
          activePage: requestData.offset / 15 + 1,
        })
      );
    }

    dispatch(PAGE.setListFilter(requestData));
    API.servicesPostData(APIURL.urlListPaymentHistory, requestData).then(
      (res) => {
        if (res.status === "fail") {
          if (isNewSearch) {
            TOA.servicesUseToast("검색하신 데이터가 없습니다.", "e");
          }
        }
        if (res.status === "success") {
          paymentList(res.data);
          dispatch(PAGE.setListPage(res.page));
        }
      }
    );
  }

  // 초기화 이벤트
  function handleReset(e) {
    API.servicesPostData(APIURL.urlListPaymentHistory, {
      offset: pageData.getPage,
      size: 15,
    }).then((res) => {
      if (res.status === "fail") {
        alert("초기화가 완료되지 않았습니다.");
      }
      if (res.status === "success") {
        paymentList(res.data);
        dispatch(PAGE.setListPage(res.page));

        reset();
        CLEAN.serviesPaginationCleanup(dispatch);
      }
    });
  }

  return (
    <div className="commonBox">
      <h3 className="blind">수납 내역 검색 필터</h3>
      <form
        className="formLayout"
        onSubmit={handleSubmit(() => fnSubmit(true))}
      >
        <fieldset>
          <div className="listSearchForm SearchFormNew">
            <div className="listSearchWrap">
              <label htmlFor="cid">
                <span>관리번호</span>
              </label>
              <div>
                <input
                  type="text"
                  id="cid"
                  {...register("_cid", {
                    pattern: {
                      value: /[0-9]/,
                      message: "숫자만 입력할 수 있습니다.",
                    },
                  })}
                />
              </div>
            </div>

            <div className="listSearchWrap">
              <label htmlFor="cdname">
                <span>상호명</span>
              </label>
              <div>
                <input type="text" id="cdname" {...register("_name")} />
              </div>
            </div>

            <div className="listSearchWrap">
              <label htmlFor="mobilenum">
                <span>휴대폰</span>
              </label>
              <div>
                <input
                  type="text"
                  id="mobilenum"
                  maxLength={14}
                  value={
                    (watch("_mobilenum") &&
                      FM.serviesFormatPhoneNumber(watch("_mobilenum"))) ||
                    ""
                  }
                  {...register("_mobilenum")}
                />
              </div>
            </div>

            <div className="listSearchWrap">
              <label htmlFor="billYM">
                <span>청구년월</span>
              </label>
              <div>
                <input type="month" id="billYM" {...register("_billYM")} />
              </div>
            </div>

            <div className="listSearchWrap">
              <label htmlFor="endDateFrom">
                <span>선납 시작일</span>
              </label>
              <div>
                <input
                  type="date"
                  id="endDateFrom"
                  {...register("_endDateFrom")}
                />
                <span> ~ </span>
                <input
                  type="date"
                  id="startDateTo"
                  {...register("_startDateTo")}
                />
              </div>
            </div>

            <div className="listSearchWrap">
              <label htmlFor="paymentDateFrom">
                <span>출금일</span>
              </label>
              <div>
                <input
                  type="date"
                  id="paymentDateFrom"
                  {...register("_paymentDateFrom")}
                />
                <span> ~ </span>
                <input
                  type="date"
                  id="paymentDateTo"
                  {...register("_paymentDateTo")}
                />
              </div>
            </div>
          </div>
        </fieldset>

        <div className="listSearchButtonWrap">
          <button type="reset" value="초기화" onClick={handleReset}>
            초기화
          </button>
          <button type="submit" value="검색">
            검색
          </button>
        </div>
      </form>
    </div>
  );
}
